<div [formGroup]="group">
  <input
    type="number"
    inputmode="decimal"
    [id]="control.name"
    [value]="control.value ?? null"
    [formControlName]="control.name"
    [attr.aria-required]="isRequired ? 'true' : 'false'"
    [attr.aria-invalid]="control.hasError ? 'true' : null"
  />
</div>
